import React, { forwardRef } from 'react';
import styled from 'styled-components';
const IconWrapper = styled.svg `
  --icon-color: currentColor;
  --icon-size: ${({ $viewportSize }) => `${$viewportSize || 20}px`};
  width: var(--icon-size-x, var(--icon-size));
  height: var(--icon-size-y, var(--icon-size));
  display: block;
`;
export const IconBase = forwardRef((props, ref) => {
    const viewportSizeX = props.viewportSizeX || props.viewportSize || 20;
    const viewportSizeY = props.viewportSizeY || props.viewportSize || 20;
    const styleProps = {
        $viewportSize: props.viewportSize,
    };
    return (React.createElement(IconWrapper, { onFocus: props.onFocus, onBlur: props.onBlur, onClick: props.onClick, onMouseEnter: props.onMouseEnter, onMouseMove: props.onMouseMove, onMouseLeave: props.onMouseLeave, onMouseDown: props.onMouseDown, onMouseUp: props.onMouseUp, viewBox: `0 0 ${viewportSizeX} ${viewportSizeY}`, fill: "none", xmlns: "http://www.w3.org/2000/svg", style: props.style, className: props.className, ref: ref, width: viewportSizeX, height: viewportSizeY, ...styleProps }, props.children));
});
//# sourceMappingURL=Base.js.map